/*
 * holiae-blog.js — Interactions Blog v4
 * HOLIAĒ — FAQ accordéon + Sommaire actif
 * À charger dans theme.liquid : <script src="{{ 'holiae-blog.js' | asset_url }}"></script>
 */

document.addEventListener('DOMContentLoaded', function() {

  /* Garde-fou : ne rien faire si pas de page blog HOLIAĒ */
  const blogPage = document.querySelector('.holiae-blog-page');
  if (!blogPage) return;

  /* ── FAQ accordéon ───────────────────────────────── */
  blogPage.querySelectorAll('.holiae-faq-item h3 button').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.holiae-faq-item');
      const isOpen = item.classList.contains('open');
      blogPage.querySelectorAll('.holiae-faq-item.open').forEach(el => {
        el.classList.remove('open');
        el.querySelector('button').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── Sommaire actif au scroll ────────────────────── */
  const anchors = blogPage.querySelectorAll('.holiae-blog-section[id], .holiae-faq[id], .holiae-conclusion[id]');
  const sideLinks = blogPage.querySelectorAll('.holiae-blog-sidebar .som-nav a');

  if (anchors.length && sideLinks.length) {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          sideLinks.forEach(l => l.classList.remove('active'));
          const a = blogPage.querySelector(`.holiae-blog-sidebar .som-nav a[href="#${e.target.id}"]`);
          if (a) a.classList.add('active');
        }
      });
    }, { rootMargin: '-15% 0px -75% 0px' });

    anchors.forEach(s => obs.observe(s));
  }

});